
import { ColDef } from "ag-grid-community"

import TargetDateRenderer from "pages/shared/target-date-renderer/TargetDateRenderer";
import EventTypeRenderer from "pages/shared/event-type-renderer/EventTypeRenderer";
import AvailableSlotsRenderer from "pages/shared/available-slots-renderer/AvailableSlotsRenderer";
import ContactCompanyRenderer from "pages/shared/contact-company-renderer/ContactCompanyRenderer";
import BudgetRenderer from "pages/shared/budget-renderer/BudgetRenderer";
import { PublicLead } from "./topchef.types";
import StatusRenderer from "pages/shared/status-renderer/StatusRenderer";



const DateTimeCellRenderer = (params: any) => {
    return (
      <TargetDateRenderer {...params.data}/>
    );
};

const EventTypeCellRenderer = (params: any) => {
  return (
    <EventTypeRenderer eventValue={params.value}/>
  );
};

const SourceCellRenderer = (params: any) => {
  return (
    <ContactCompanyRenderer contactCompany={params.value}/>
  );
};

const AvailableSlotsCellRenderer = (params: any) => {
  return (
    <AvailableSlotsRenderer availableSlots={params.value}/>
  );
};


const BudgetCellRenderer = (params: any) => {
  return (
    <BudgetRenderer amount={params.value}/>
  );
};

const StatusCellRenderer = (params: any) => {
  return (
    <StatusRenderer status={params.value} />
  );
};

export interface PublicLeadDefinitionProps {
    detailsRenderer: any,
}

export const getPublicLeadColumnDefinition = (params: PublicLeadDefinitionProps): ColDef<PublicLead>[] => [
    { field: "source", headerName: "Origine", wrapText:true, minWidth: 120, cellRenderer: SourceCellRenderer },
    { field: "contactCompany", headerName: "Entreprise", minWidth: 120},
    { field: "type", headerName: "Événement", minWidth: 120, cellRenderer: EventTypeCellRenderer},
    { field: "targetDate", headerName: "Date", minWidth: 80, maxWidth: 100, cellRenderer: DateTimeCellRenderer },
    { field: "guests", headerName: "Pax", maxWidth: 70 },
    { field: "budget", headerName: "Budget HT", maxWidth: 95, cellRenderer: BudgetCellRenderer },
    { field: "city", headerName: "Ville" },
    { field: "availableSlots", headerName: "Places dispos", minWidth: 100, maxWidth: 120, cellRenderer: AvailableSlotsCellRenderer },
    { field: "status", headerName: "Statut", minWidth: 100, cellRenderer: StatusCellRenderer },
    { field: "id", headerName: "Détails", minWidth: 80, maxWidth: 100, cellRenderer: params.detailsRenderer },
];